<script>
  import { getContext } from 'svelte';
  import TextInput from '../../../../components/inputs/text';
  import SwitchInput from '../../../../components/inputs/switch';
  import AvatarInput from '../../../../components/inputs/avatar';
  import TextAreaInput from '../../../../components/inputs/textarea';
  import CoordinatorInput from '../../../../components/inputs/coordinator';
  import CategoryInput from '../../../../components/inputs/category';
  import AnnualScheduleInput from '../../../../components/inputs/schedule';
  import Form from '../../../../components/inputs/form';
  import SectionNav from '../../../../components/navigation/section';
  import { UPDATE_HOUSEHOLD } from '../../../../graphql/households';
  import {
    addNotification,
    ICONS
  } from '../../../../utils/notifications.store';

  export let value;

  const client = getContext('apollo');

  async function save() {
    const input = {
      vip: value.vip,
      constraintVipAllowance: value.constraintVipAllowance ? parseInt(value.constraintVipAllowance) : vale.constraintVipAllowance
    };
    try {
      await client.mutate({
        mutation: UPDATE_HOUSEHOLD,
        variables: {
          id: value.id,
          input
        }
      });

      addNotification({
        message: 'Saved VIP Info',
        icon: ICONS.SUCCESS,
        time: 2000
      });
    } catch (e) {
      console.log(e);
    }
  }
</script>

<style>
  h2 {
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
    font-weight: 500;
    font-size: 13px;
    line-height: 21.034px;
    margin: 0;
  }

  h2.lbl {
    font-size: 11px;
    text-transform: uppercase;
    margin: 8px 0;
    font-weight: 700;
  }

  h1 {
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
    font-weight: 700;
    font-size: 16px;
    line-height: 21.034px;
    margin: 0;
    background: #fbfbfb;
    padding: 16px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .household-info {
    padding: 16px;
  }
</style>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <Form>
      <div class="form-group">
        <SwitchInput bind:value="{value.vip}" label="IS VIP?" placeholder="IS VIP?" name="vip"></SwitchInput>
      </div>
      <div class="grid-x">
        <div class="cell small-12 medium-4">
          <div class="form-group">
            <TextInput bind:value="{value.constraintVipAllowance}" label="VIP registrations per year"
              placeholder="VIP registrations per year"></TextInput>
          </div>
        </div>
      </div>
    </Form>
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav>
      <h1>Household Information</h1>
      <div class="household-info">
        <h2 class="lbl">Primary Contact</h2>
        <h2>
          {value.primary.person.firstName} {value.primary.person.lastName}
        </h2>
        <h2>
          <a href="mailto:{value.primary.user.email}">{value.primary.user.email}</a>
        </h2>
        <h2>{value.primary.user.phone}</h2>
        <h2 class="lbl">Address</h2>
        <h2>
          {value.primary.person.addressLineOne}{#if
          value.primary.person.addressLineTwo},
          {value.primary.person.addressLineTwo}{/if}<br />{value.primary.person.city},
          {value.primary.person.state} {value.primary.person.postal}
        </h2>
      </div>
      <div on:click="{save}" class="save bottom">
        SAVE HOUSEHOLD
      </div>
    </SectionNav>
  </div>
</div>